import jQuery from "jquery";
import "slick-carousel";


(function ($) {
  $(document).ready(function () {
    // =============================
    // LAYOUT 1
    // =============================
    $(".slider-area").each(function () {
    const $root        = $(this);
    const $sliderArea  = $root.find(".slick-container");
    const $textSlider  = $root.parent().find(".text-slider");
    const $dots        = $root.parent().find(".carousel-dots");
    const $prev        = $root.parent().find(".custom-prev");
    const $next        = $root.parent().find(".custom-next");

    if ($sliderArea.length && $sliderArea.children().length) {
      $sliderArea.slick({
        infinite: true,
        slidesToShow: 1,
        arrows: false,
        dots: false,
        swipe: true,
        draggable: true,
        adaptiveHeight: false,
        ...( $textSlider.length ? { asNavFor: $textSlider } : {} ),
        ...( $prev.length && $next.length ? { arrows: true, prevArrow: $prev, nextArrow: $next } : {} ),
      });
      $sliderArea.slick("setPosition");
    }
    

    if ($textSlider.length && $textSlider.children().length) {
      $textSlider.slick({
        infinite: true,
        fade: true,
        arrows: false,
        ...( $sliderArea.length ? { asNavFor: $sliderArea } : {} ),
      });
    }

    if ($dots.length && $sliderArea.hasClass("slick-initialized")) {
      const slideCount = $sliderArea.slick("getSlick").slideCount;
      $dots.empty();
      for (let i = 0; i < slideCount; i++) {
        $dots.append(`<button class="dot" data-slide="${i}"></button>`);
      }
      const setDot = (i) => {
        $dots.find(".dot").removeClass("slick-active")
            .filter(`[data-slide="${i}"]`).addClass("slick-active");
      };
      $sliderArea.on("afterChange", (e, slick, i) => setDot(i));
      setDot(0);
    }

    if ($prev.length) $prev.on("click", () => $sliderArea.slick("slickPrev"));
    if ($next.length) $next.on("click", () => $sliderArea.slick("slickNext"));
  });

// =============================
// LAYOUT 2
// =============================
// $(".carousel-section").each(function () {
//   const $root         = $(this);
//   const $textSlider   = $root.find(".text-slider");
//   const $dotsContainer= $root.find(".carousel-dots");
//   const $prevArrow    = $root.find(".custom-prev");
//   const $nextArrow    = $root.find(".custom-next");

//   if ($textSlider.length && $textSlider.children().length) {
//     $textSlider.slick({
//       infinite: true,
//       fade: false,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       arrows: false,
//       dots: false,
//       swipe: true,
//       draggable: true,
//       adaptiveHeight: true,
//     });

//     if ($textSlider.hasClass("slick-initialized")) {
//       $textSlider.slick("setPosition");
//       $textSlider.slick("refresh");
//     }
//   }

//   if ($dotsContainer.length && $textSlider.hasClass("slick-initialized")) {
//     const slideCount = $textSlider.slick("getSlick").slideCount;
//     $dotsContainer.empty();
//     for (let i = 0; i < slideCount; i++) {
//       $dotsContainer.append($("<button>").addClass("dot").attr("data-slide", i));
//     }
//     const updateActiveDot = (i) => {
//       $dotsContainer.find(".dot").removeClass("slick-active")
//                     .filter(`[data-slide="${i}"]`).addClass("slick-active");
//     };
//     $textSlider.on("afterChange", (e, slick, i) => updateActiveDot(i));
//     $dotsContainer.on("click", ".dot", function () {
//       const index = $(this).data("slide");
//       if ($textSlider.hasClass("slick-initialized")) $textSlider.slick("slickGoTo", index);
//     });
//     updateActiveDot(0);
//   }

//   if ($prevArrow.length) $prevArrow.on("click", () => {
//     if ($textSlider.hasClass("slick-initialized")) $textSlider.slick("slickPrev");
//   });
//   if ($nextArrow.length) $nextArrow.on("click", () => {
//     if ($textSlider.hasClass("slick-initialized")) $textSlider.slick("slickNext");
//   });

//   $(window).on("resize", () => {
//     if ($textSlider.hasClass("slick-initialized")) $textSlider.slick("refresh");
//   });
// });

    // =============================
    // LAYOUT 3
    // =============================
const layout3Selector = '.carousel-section[data-layout="layout_3"]';

$(layout3Selector).each(function () {
  const $root         = $(this);
  const $slider       = $root.find(".slick-container");
  const $dotsContainer= $root.find(".carousel-dots");
  const $prevArrow    = $root.find(".custom-prev");
  const $nextArrow    = $root.find(".custom-next");

  if ($slider.length && $slider.children().length) {
    const options = {
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      variableWidth: false,
      centerPadding: "0",
      arrows: false,
      dots: false,
      swipe: true,
      draggable: true,
    };

    if ($prevArrow.length && $nextArrow.length) {
      options.arrows    = true;
      options.prevArrow = $prevArrow;
      options.nextArrow = $nextArrow;
    }

    $slider.slick(options);

    if ($slider.hasClass("slick-initialized")) {
      $slider.slick("setPosition");
    }
  }

  if ($dotsContainer.length && $slider.hasClass("slick-initialized")) {
    const slideCount = $slider.slick("getSlick").slideCount;
    $dotsContainer.empty();
    for (let i = 0; i < slideCount; i++) {
      $dotsContainer.append($("<button>").addClass("dot").attr("data-slide", i));
    }
    const updateActiveDot = (i) => {
      $dotsContainer.find(".dot").removeClass("slick-active")
                    .filter(`[data-slide="${i}"]`).addClass("slick-active");
    };
    $slider.on("afterChange", (e, slick, i) => updateActiveDot(i));
    $dotsContainer.on("click", ".dot", function () {
      const index = $(this).data("slide");
      if ($slider.hasClass("slick-initialized")) $slider.slick("slickGoTo", index);
    });
    updateActiveDot(0);
  }

  if ($prevArrow.length) $prevArrow.on("click", () => {
    if ($slider.hasClass("slick-initialized")) $slider.slick("slickPrev");
  });
  if ($nextArrow.length) $nextArrow.on("click", () => {
    if ($slider.hasClass("slick-initialized")) $slider.slick("slickNext");
  });

  $(window).on("resize", () => {
    if ($slider.hasClass("slick-initialized")) $slider.slick("refresh");
  });
});


  // =============================
  // LAYOUT 4 (TESTIMONIALS)
  // =============================
  const layoutTestimonialSelector = '.carousel-section[data-layout="layout_testimonial"]';

  $(layoutTestimonialSelector).each(function () {
    const $slider = $(this).find(".slick-container");
    const $dotsContainer = $(this).find(".carousel-dots");
    const $prevArrow = $(this).find(".custom-prev");
    const $nextArrow = $(this).find(".custom-next");

    // Only init if we have slides
    if ($slider.length && $slider.children().length > 0) {
      $slider.slick({
        infinite: true,       
        slidesToShow: 3,     
        slidesToScroll: 1,
        centerMode: false,   
        arrows: false,        
        dots: false,          
        swipe: true,
        draggable: true,
        touchThreshold: 10,
        prevArrow: $prevArrow.length ? $prevArrow : null,
        nextArrow: $nextArrow.length ? $nextArrow : null,

        responsive: [
          {
            breakpoint: 700, 
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 1300, 
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 1450,
            settings: {
              slidesToShow: 3,
            }
          }
        ]
      });
      
    $slider.on("init", function (event, slick) {
      const currentSlide = slick.currentSlide || 0;
      setActiveSlide(currentSlide);
    });
    $slider.on("afterChange", function (event, slick, currentSlide) {
      setActiveSlide(currentSlide);
    });
    $slider.on("touchstart", ".slick-slide.active", function (e) {
      $(this).addClass("touch-active"); 
    });

    $slider.on("touchend touchcancel", ".slick-slide.touch-active", function (e) {
      $(this).removeClass("touch-active"); // Remove temporary class
    });
      $slider.slick("setPosition");
      setActiveSlide(0);

      function setActiveSlide(currentSlide) {
        $slider.find(".slick-slide").removeClass("active");
        $slider
          .find('.slick-slide[data-slick-index="' + currentSlide + '"]')
          .addClass("active");
      }
    }

    // Create custom dots if we have a container
    if ($dotsContainer.length && $slider.hasClass("slick-initialized")) {
      const slideCount = $slider.slick("getSlick").slideCount;
      $dotsContainer.empty();
      for (let i = 0; i < slideCount; i++) {
        let dot = $("<button>").addClass("dot").attr("data-slide", i);
        $dotsContainer.append(dot);
      }
      function updateActiveDot(currentSlide) {
        $dotsContainer.find(".dot").removeClass("slick-active");
        $dotsContainer
          .find(`.dot[data-slide="${currentSlide}"]`)
          .addClass("slick-active");
      }
      $slider.on("afterChange", function (event, slick, currentSlide) {
        updateActiveDot(currentSlide);
      });
      $dotsContainer.on("click", ".dot", function () {
        const index = $(this).data("slide");
        $slider.slick("slickGoTo", index);
      });
      updateActiveDot(0);
    }
    $prevArrow.on("click", function () {
      $slider.slick("slickPrev");
    });
    $nextArrow.on("click", function () {
      $slider.slick("slickNext");
    });
    $(window).on("resize", function () {
      $slider.slick("refresh");
    });
  });

  });
})(jQuery);


// Team Layout Last Child on right column
document.addEventListener('DOMContentLoaded', () => {
  const grid = document.getElementById('team-grid');
  if (!grid) return;

  function apply() {
    const items = Array.from(grid.children);   // recalc each run
    const w = window.innerWidth;
    const isDesktop3Col = w >= 1351;           // matches your CSS

    // reset
    items.forEach(el => el.classList.remove('move-to-third-col'));
    grid.style.removeProperty('padding-bottom');

    const n = items.length;
    if (!n) return;

    if (isDesktop3Col) {
      const lastIndex = n - 1;
      const lastCol = lastIndex % 3; // 0=left (1 item), 1=middle (2 items), 2=right (full row)

      if (lastCol === 1) {
        // last row has 2 items → push last to col 3; NO padding
        items[lastIndex].classList.add('move-to-third-col');
      } else if (lastCol === 2) {
        // full last row → add padding
        grid.style.paddingBottom = '300px';
      }
      // lastCol === 0 → 1 item last row → no padding
    }
    // ≤1350px (2/1 cols) → never add padding
  }

  // run now
  apply();

  // re-run on resize/orientation (debounced via rAF)
  const rerun = (() => {
    let id;
    return () => {
      cancelAnimationFrame(id);
      id = requestAnimationFrame(apply);
    };
  })();

  window.addEventListener('resize', rerun);
  window.addEventListener('orientationchange', rerun);
  window.addEventListener('load', rerun);

  // also re-run exactly when the 1351px breakpoint flips
  const mql = window.matchMedia('(min-width: 1351px)');
  (mql.addEventListener || mql.addListener).call(mql, 'change', rerun);

  // optional: if container width can change without window resize (e.g., side panel),
  // observe layout changes:
  const ro = new ResizeObserver(rerun);
  ro.observe(document.documentElement);
});




// Text Rotation Animation & Fade Out
document.addEventListener("DOMContentLoaded", function () {
  const texts = document.querySelectorAll(".hero-text");
  const heroSection = document.querySelector(".hero-section");
  const heroContent = document.querySelector(".hero-content");

  function rotateText() {
    texts.forEach((text) => {
      text.style.opacity = "0";
      text.style.transform = "translateY(10px)";
      text.style.transition = "opacity 1s ease-in-out, transform 1s ease-in-out";
    });
    if (texts[currentIndex]) {
      texts[currentIndex].style.opacity = "1";
      texts[currentIndex].style.transform = "translateY(0)";
    }
    setTimeout(() => {
      if (texts[currentIndex]) {
        texts[currentIndex].style.opacity = "0";
        texts[currentIndex].style.transform = "translateY(-10px)";
      }
      currentIndex = (currentIndex + 1) % texts.length;
      rotateText();
    }, 2000);
  }

  let currentIndex = 0;
  if (texts.length > 0) setTimeout(rotateText, 500);

  // Only create observer if BOTH elements exist
  if (heroSection && heroContent) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const scrollProgress = entry.boundingClientRect.bottom / window.innerHeight;
          const opacityValue = Math.max(0, (scrollProgress - 0.42) * 2);
          heroContent.style.opacity = entry.boundingClientRect.top >= 0 ? 1 : opacityValue;
        });
      },
      { threshold: Array.from({ length: 21 }, (_, i) => i * 0.05) }
    );
    observer.observe(heroSection);
  }
});


    // Safari fix for <details>
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('.accordion-block summary').forEach(function(summary) {
        summary.style.cursor = 'pointer';
        summary.addEventListener('click', function(e) {
          const details = summary.parentNode;
          e.preventDefault();
          if (details.hasAttribute('open')) {
            details.removeAttribute('open');
          } else {
            details.setAttribute('open', '');
          }
        });
      });
      // Only one open at a time
      const accordions = document.querySelectorAll(".accordion-block");
      accordions.forEach((accordion) => {
        accordion.addEventListener("toggle", function () {
          if (accordion.open) {
            accordions.forEach((other) => {
              if (other !== accordion) other.removeAttribute("open");
            });
          }
        });
      });
    });

/////////// Footer Icons
document.querySelectorAll('.social-icon').forEach(icon => {
  icon.addEventListener('mouseenter', function() {
    this.style.transition = "opacity 0.3s ease-in-out"; 
    this.style.opacity = "0"; 

    setTimeout(() => {
      this.src = this.dataset.hover; 
      this.style.opacity = "1";
    }, 150); 
  });
  icon.addEventListener('mouseleave', function() {
    this.style.transition = "opacity 0.3s ease-in-out";
    this.style.opacity = "0";

    setTimeout(() => {
      this.src = this.dataset.default; 
      this.style.opacity = "1";
    }, 150);
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const toggles = document.querySelectorAll('input[id^="submenu-toggle-"]');

  toggles.forEach((toggle) => {
    toggle.addEventListener('change', () => {
      if (toggle.checked) {
        toggles.forEach((other) => {
          if (other !== toggle) {
            other.checked = false;
          }
        });
      }
    });
  });
});




//////// Services Section
document.addEventListener('change', (e) => {
  if (window.innerWidth >= 1024) return; 
  const r = e.target;
  if (!r.matches('#accordion-group input[type="radio"]')) return;

  const label =
    r.nextElementSibling?.classList?.contains('service-tab')
      ? r.nextElementSibling
      : document.querySelector(`label[for="${r.id}"]`);

  if (!label) return;

  setTimeout(() => {
    label.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, 600);
});





///////// Preloader
document.addEventListener('DOMContentLoaded', () => {
  const preloader = document.getElementById('preloader');
  if (!preloader) {
    document.body.classList.remove('opacity-0');
    return;
  }

  const body = document.body;
  const maskRect = preloader.querySelector('#mask-rect');

  const fadeOut = () => {
    if (!preloader.isConnected) {
      body.classList.remove('opacity-0');
      return;
    }
    preloader.style.opacity = '0';
    preloader.style.pointerEvents = 'none';
    setTimeout(() => {
      preloader.remove?.();
      body.classList.remove('opacity-0');
    }, 600);
  };

  if (maskRect) {
    ['animationend', 'webkitAnimationEnd', 'transitionend'].forEach(evt =>
      maskRect.addEventListener(evt, fadeOut, { once: true })
    );
    const cs = getComputedStyle(maskRect);
    const toMs = s => (s.endsWith('ms') ? parseFloat(s) : parseFloat(s) * 1000);
    const maxVal = str => Math.max(0, ...str.split(',').map(v => toMs(v.trim())));
    const total = (maxVal(cs.animationDuration) + maxVal(cs.animationDelay)) ||
                  (maxVal(cs.transitionDuration) + maxVal(cs.transitionDelay)) || 2000;
    setTimeout(fadeOut, total + 100);
  } else {
    window.addEventListener('load', fadeOut, { once: true });
  }
});

// Back to top scroll effect on single-case-study twig
  document.getElementById('backToTop')?.addEventListener('click', (e) => {
    if (window.lenis && typeof window.lenis.scrollTo === 'function') {
      e.preventDefault();
      window.lenis.scrollTo(0);
    }
  });



////////// What we offer Section
const accordionHeaders = document.querySelectorAll('[data-accordion-toggle]');

accordionHeaders.forEach(header => {
  header.addEventListener('click', function () {
    const content = this.nextElementSibling;
    const icon = this.querySelector('.accordion-icon');
    const line = this.parentElement.querySelector('.line');

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
      icon.src = `${icon.src.replace('minus.svg', 'plus.svg')}`; 
      if (line) line.style.marginTop = '0'; 
    } else {
      document.querySelectorAll('.accordion-content').forEach(c => {
        c.style.maxHeight = null;
        const siblingLine = c.parentElement.querySelector('.line');
        if (siblingLine) siblingLine.style.marginTop = '0';
        c.previousElementSibling.querySelector('.accordion-icon').src = c.previousElementSibling.querySelector('.accordion-icon').src.replace('minus.svg', 'plus.svg');
      });

      content.style.maxHeight = content.scrollHeight + 'px'; 
      icon.src = `${icon.src.replace('plus.svg', 'minus.svg')}`; 
      if (line) line.style.marginTop = '16px';
    }
  });
});




///// Navbar transparent Scroll Effect
// --- Transparent-on-hero ---
const navbar = document.querySelector('#navbar'); // use one var consistently
const sectionOne = document.querySelector('.home-intro');
const usesDarkHeader = navbar?.classList.contains('start-white-bg');

if (navbar && !usesDarkHeader) {
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) navbar.classList.add('nav-scrolled');
      else navbar.classList.remove('nav-scrolled');
    });
  });

  if (sectionOne) io.observe(sectionOne);
  else navbar.classList.add('nav-scrolled');
} else {
  navbar?.classList.remove('nav-scrolled');
}

// --- Show/hide on scroll (no threshold) ---
document.addEventListener('DOMContentLoaded', () => {
  const nLogo = document.querySelector('.logo-n');
  const defaultLogo = document.querySelector('.logo-default');
  const headerTextEls = document.querySelectorAll('.nav-link, .logo-n, .logo-default');

  let lastY = window.lenis ? window.lenis.scroll : window.scrollY;
  let isHidden = false;

  const toggleLogo = (dir, y) => {
    if (y > 50) {
      nLogo?.classList.remove('hidden');
      defaultLogo?.classList.add('hidden');
    } else {
      nLogo?.classList.add('hidden');
      defaultLogo?.classList.remove('hidden');
    }
  };

  const toggleHeaderText = (dir) => {
    headerTextEls.forEach(el => {
      if (dir === 'down') {
        el.classList.add('fade-out-text');
        el.classList.remove('fade-in-text');
      } else {
        el.classList.add('fade-in-text');
        el.classList.remove('fade-out-text');
      }
    });
  };

  const handle = (y) => {
    const dir = y > lastY ? 'down' : 'up';

    if (y <= 0) {
      navbar?.classList.remove('hidden-navbar');
      isHidden = false;
    } else {
      if (dir === 'down' && !isHidden && y > 50) {
        navbar?.classList.add('hidden-navbar');
        isHidden = true;
      } else if (dir === 'up' && isHidden) {
        navbar?.classList.remove('hidden-navbar');
        isHidden = false;
      }
    }

    toggleLogo(dir, y);
    toggleHeaderText(dir);
    lastY = y;
  };

  if (window.lenis) {
    window.lenis.on('scroll', ({ scroll }) => handle(scroll));
  } else {
    const onWinScroll = () => handle(window.scrollY);
    window.addEventListener('scroll', () => requestAnimationFrame(onWinScroll), { passive: true });
  }

  // initial pass
  handle(lastY);
});



// Lenis Scroll Animation
  document.addEventListener('DOMContentLoaded', () => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const lenis = new Lenis({
      duration: 1,
      smoothWheel: true, 
    });

    window.lenis = lenis;

    lenis.on('scroll', (e) => {
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
  });



//////// Our Team/Clients Pages
document.addEventListener("DOMContentLoaded", function () {
  const teamMembers = document.querySelectorAll(".team-member");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          const memberImage = entry.target.querySelector(".team-image");
          const name = entry.target.querySelector(".team-name");
          const position = entry.target.querySelector(".team-position");
          if (entry.intersectionRatio > 0.5) {
            setTimeout(() => {
              entry.target.classList.add("show");
            }, index * 150); 
            if (name) {
              setTimeout(() => {
                name.classList.add("show-text");
              }, index * 200 + 300);
            }
            if (position) {
              setTimeout(() => {
                position.classList.add("show-text");
              }, index * 200 + 500); 
            }
            observer.unobserve(entry.target);
          }
        }
      });
    },
    {
      rootMargin: "0px 0px -30px 0px", 
      threshold: 0.6, 
    }
  );
  teamMembers.forEach((member) => observer.observe(member));
});


////////// Services CTA
document.querySelectorAll('.service-card').forEach(card => {
  card.addEventListener('mouseenter', function(event) {
    const overlay = this.querySelector('.hover-overlay');
    const { width, height, left, top } = this.getBoundingClientRect();
    const x = event.clientX - left;
    const y = event.clientY - top;

    const fromLeft = x < width * 0.25;
    const fromRight = x > width * 0.75;
    const fromTop = y < height * 0.25;
    const fromBottom = y > height * 0.75;

    overlay.classList.remove('from-left', 'from-right', 'from-top', 'from-bottom');

    if (fromLeft) {
      overlay.classList.add('from-left');
    } else if (fromRight) {
      overlay.classList.add('from-right');
    } else if (fromTop) {
      overlay.classList.add('from-top');
    } else if (fromBottom) {
      overlay.classList.add('from-bottom');
    }
  });
});
